import { render, staticRenderFns } from "./MainModeFlashCardItem.vue?vue&type=template&id=4013d0ba&"
import script from "@/scripts/MainMode/MainModeCourse/MainModeFlashCardLanding/components/MainModeFlashCardItem.js?vue&type=script&lang=js&"
export * from "@/scripts/MainMode/MainModeCourse/MainModeFlashCardLanding/components/MainModeFlashCardItem.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports